import { waitForClientSdkToLoadOrTimeout } from '../clientSdk'
import { getEnv } from '../env'
import type { DeviceApi } from './deviceApi'
import { DeviceApiNative } from './DeviceApiNative'
import { DeviceApiSdk, clientInfoFromJsBridgeSdk } from './DeviceApiSdk'
import { DeviceApiWeb } from './DeviceApiWeb'
import type { JsBridgeSdk, JsBridgeMiniOfA } from './jsBridge'
import log from 'loglevel'

// Returns appropriate "client api" implementation based on
// current context - if its either web (our 'mock' one) or native.
export async function deviceApiFactory(): Promise<DeviceApi> {
  const windowObj = window
  if (!('mobilemissions' in windowObj)) {
    log.debug(
      'no window.mobilemissions indicates its not native webview, can be either client sdk or web'
    )

    log.debug('waiting of client sdk')

    const waitResult = await waitForClientSdkToLoadOrTimeout(getEnv('clientSdkJsApiWaitTimeMs'))

    if (waitResult.status === 'timeouted') {
      log.debug(`Client sdk load timeouted after ${waitResult.timeoutMs}ms.`)
      log.debug(
        `Using DeviceApiWeb as it looks like neither window.mobilemissions nor window.momi available.`
      )
      return new DeviceApiWeb()
    } else {
      if (!('momi' in windowObj)) {
        throw new Error('No window.momi attribute found despite momi being loaded.')
      }

      const jsBridgeSdk = windowObj.momi as Partial<JsBridgeSdk>

      const clientInfo = await clientInfoFromJsBridgeSdk(jsBridgeSdk)

      return new DeviceApiSdk(jsBridgeSdk, clientInfo)
    }
  }

  const maybeDeviceApi = windowObj.mobilemissions as Partial<JsBridgeMiniOfA>

  log.debug("Using DeviceApiNative as 'mobilemissions' is injected into window.")
  return new DeviceApiNative(maybeDeviceApi)
}
